import { trackEvent } from './register/omega'
import { PAGE_LIST } from '../constants/new-credit'
import { useState } from '../utils/store'
import { ICreditCommonStoreState } from '../store/modules/credit-common'

const pageIdMap: Record<string, string> = {
  [PAGE_LIST.cardSeparatePersonalInfo1]: '个人信息页',
  [PAGE_LIST.creditGrantPage]: '征信授权页',
  [PAGE_LIST.curpPage]: '姓名&curp页',
  [PAGE_LIST.phaseOneLoading]: '结果等待页',
}

const getCurrentPageId = (): string => {
  const page = useState<ICreditCommonStoreState>('credit-common', ['page'])?.page
  return page ? (pageIdMap[page] || page) : (window.location?.pathname || 'unknown')
}

export const addBackPopup = () => {
  const handlePopState = () => {
    const pageId = getCurrentPageId()
    trackEvent('fin_credit_abroad_last_page_ck', {
      pageid: pageId,
    })
  }

  window.addEventListener('popstate', handlePopState)

  window.addEventListener('beforeunload', (e) => {
    e.preventDefault()
  })

  return () => {
    window.removeEventListener('popstate', handlePopState)
  }
}

export const trackLastPageClick = (page: string) => {
  const pageId = pageIdMap[page] || page
  trackEvent('fin_credit_abroad_last_page_ck', {
    pageid: pageId,
  })
}
